import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/home/icon-1.png'
import _imports_1 from '../../../assets/home/icon-2.png'


const _hoisted_1 = { class: "flex flex-jc-sb gap-20" }
const _hoisted_2 = { class: "flex-item flex-1 border mg-l-16" }
const _hoisted_3 = { class: "flex flex-ai-c" }
const _hoisted_4 = { class: "flex align-center" }
const _hoisted_5 = { class: "ml-15px" }
const _hoisted_6 = { class: "mg-l-10" }
const _hoisted_7 = { class: "fs-18 bold" }
const _hoisted_8 = { class: "mg-l-10 bg" }
const _hoisted_9 = { class: "flex mg-t-20" }
const _hoisted_10 = { class: "flex align-center" }
const _hoisted_11 = { class: "ml-15px" }
const _hoisted_12 = { class: "fs-14 mg-t-5 text-i bold" }
const _hoisted_13 = { class: "mg-l-30" }
const _hoisted_14 = { class: "flex align-center" }
const _hoisted_15 = { class: "ml-15px" }
const _hoisted_16 = { class: "fs-14 mg-t-5 text-i bold" }
const _hoisted_17 = { class: "mg-l-30" }
const _hoisted_18 = { class: "flex align-center" }
const _hoisted_19 = { class: "ml-15px" }
const _hoisted_20 = { class: "fs-14 mg-t-5 text-i bold" }
const _hoisted_21 = { class: "flex-item flex-1 mg-l-30" }
const _hoisted_22 = { class: "flex flex-ai-c" }
const _hoisted_23 = { class: "flex align-center" }
const _hoisted_24 = { class: "ml-15px" }
const _hoisted_25 = { class: "mg-l-10" }
const _hoisted_26 = { class: "fs-18 bold" }
const _hoisted_27 = { class: "mg-l-10 bg" }
const _hoisted_28 = { class: "flex mg-t-20" }
const _hoisted_29 = { class: "flex align-center" }
const _hoisted_30 = { class: "ml-15px" }
const _hoisted_31 = { class: "fs-14 mg-t-5 text-i bold" }
const _hoisted_32 = { class: "mg-l-30" }
const _hoisted_33 = { class: "flex align-center" }
const _hoisted_34 = { class: "ml-15px" }
const _hoisted_35 = { class: "fs-14 mg-t-5 text-i bold" }
const _hoisted_36 = { class: "mg-l-30" }
const _hoisted_37 = { class: "flex align-center" }
const _hoisted_38 = { class: "ml-15px" }
const _hoisted_39 = { class: "fs-14 mg-t-5 text-i bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "icon",
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fs-12 fc-lightgray mg-l-10" }, "已发金额", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_popover, {
              class: "text-[#5E617D]",
              content: "所选时间段内发放薪资总计",
              placement: "right-end"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, { color: "#9497B1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fs-12" }, "¥", -1)),
          _createElementVNode("i", _hoisted_7, _toDisplayString(_ctx.detail.payTotalMoney), 1)
        ]),
        _createElementVNode("div", _hoisted_8, "共" + _toDisplayString(_ctx.detail.payOrderCount) + "个项目", 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fs-12 fc-lightgray" }, "已领金额", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_popover, {
                class: "text-[#5E617D]",
                content: "所选时间段内，员工实际领取的薪资总额（仅发薪，按发放时间统计）",
                placement: "right-end"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { color: "#9497B1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "¥", -1)),
            _createTextVNode(_toDisplayString(_ctx.detail.payReceiveTotalMoney), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fs-12 fc-lightgray" }, "待领金额", -1)),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_popover, {
                class: "text-[#5E617D]",
                content: "所选时间段内，已发放但未领取的薪资总额（仅发薪，按发放时间统计）",
                placement: "right-end"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { color: "#9497B1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "¥", -1)),
            _createTextVNode(_toDisplayString(_ctx.detail.payAvailableTotalMoney), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "fs-12 fc-lightgray mr-15px" }, "停发金额", -1)),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_popover, {
                class: "text-[#5E617D]",
                content: "所选时间段内，停止发放的金额总计（仅发薪，按发放时间统计）",
                placement: "right-end"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { color: "#9497B1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "¥", -1)),
            _createTextVNode(_toDisplayString(_ctx.detail.payStopTotalMoney), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[11] || (_cache[11] = _createElementVNode("img", {
          class: "icon",
          src: _imports_1,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", _hoisted_23, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fs-12 fc-lightgray mg-l-10" }, "已发预支", -1)),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_popover, {
              class: "text-[#5E617D]",
              content: "所选时间段内预支发放薪资总计",
              placement: "right-end"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, { color: "#9497B1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "fs-12" }, "¥", -1)),
          _createElementVNode("i", _hoisted_26, _toDisplayString(_ctx.detail.totalPracticalAdvanceAmount), 1)
        ]),
        _createElementVNode("div", _hoisted_27, "共" + _toDisplayString(_ctx.detail.advanceOrderCount) + "笔", 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_29, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "fs-12 fc-lightgray" }, "已领预支", -1)),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_el_popover, {
                class: "text-[#5E617D]",
                content: "所选时间段内，员工实际领取的薪资总额（仅预支，按发放时间统计）",
                placement: "right-end"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { color: "#9497B1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "¥", -1)),
            _createTextVNode(_toDisplayString(_ctx.detail.totalSalaryAdvanceAmount), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "fs-12 fc-lightgray" }, "待领预支", -1)),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_popover, {
                class: "text-[#5E617D]",
                content: "所选时间段内，已发放但未领取的薪资总额（仅预支，按发放时间统计）",
                placement: "right-end"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { color: "#9497B1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "¥", -1)),
            _createTextVNode(_toDisplayString(_ctx.detail.totalUnclaimedAdvanceAmount), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "fs-12 fc-lightgray" }, "停发预支", -1)),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_el_popover, {
                class: "text-[#5E617D]",
                content: "所选时间段内，停止发放的金额总计（仅预支，按发放时间统计）",
                placement: "right-end"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, { color: "#9497B1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[17] || (_cache[17] = _createElementVNode("span", null, "¥", -1)),
            _createTextVNode(_toDisplayString(_ctx.detail.totalStopAdvanceAmount), 1)
          ])
        ])
      ])
    ])
  ]))
}